import { Dialog, FormInput, Loader } from "@/components";
import { FC } from "react";
import { MonthlyDistributionProps } from "./types";
import useMonthlyDistribution from "./useMonthlyDistribution";
import moment from "moment";
import { FormProvider } from "react-hook-form";
import { Button, DialogClose, DialogFooter } from "@/components/ui";
import { formatAmount } from "@/lib/utils";

const MonthlyDistribution: FC<MonthlyDistributionProps> = ({
  openDistributionDialog,
  setOpenDistributionDialog,
  annualBudget,
  onSave,
  rowSelected,
  isView,
  draftDistributionData,
}) => {
  const {
    budgetData,
    form,
    onSubmit,
    totalAmt,
    onClear,
    onCloseDialog,
    isDistributionLoading,
  } = useMonthlyDistribution({
    annualBudget,
    onSave,
    setOpenDistributionDialog,
    rowSelected,
    draftDistributionData,
  });
  const { errors } = form.formState;

  return (
    <Dialog
      open={openDistributionDialog}
      setOpen={setOpenDistributionDialog}
      title={
        <div className="flex item-end">
          Monthly Distribution
          <div className="text-sm text-primary ml-2">
            {budgetData?.budgetName} [Year {budgetData?.year} (Version{" "}
            {budgetData?.versionNo})]
          </div>
        </div>
      }
      contentClassName="lg:!max-w-[1200px] lg:!w-[1200px]"
      hideFooter
    >
      {/* {budgetData?.glMasterId} */}
      {isDistributionLoading ? (
        <Loader />
      ) : (
        <FormProvider {...form}>
          <form onSubmit={form.handleSubmit(onSubmit)}>
            {!isView && (
              <div className="flex items-center justify-end mb-3">
                <Button
                  variant="ghost"
                  className="text-red-600 hover:text-red-600"
                  onClick={onClear}
                >
                  Clear All
                </Button>
              </div>
            )}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-1">
              {moment.monthsShort()?.map((mon: string, index: number) => {
                return (
                  <div className="flex flex-col gap-1 lg:gap-2 items-center">
                    <div>{mon}</div>
                    <div className="py-2 lg:py-2">
                      <FormInput
                        name={`amountM${index + 1}`}
                        control={form.control}
                        placeholder="0"
                        error={(errors as any)[`amountM${index + 1}`]?.message}
                        variant="float"
                        isRequired={false}
                        startIcon={<span>$</span>}
                        disabled={isView}
                      />
                    </div>
                  </div>
                );
              })}
            </div>
            <div className="mt-2 flex flex-row items-center justify-between">
              <div className="text-primary text-20px font-bold">
                Annual Budget: {formatAmount(annualBudget ? annualBudget : 0)}
              </div>
              <div className="text-primary text-20px font-bold">
                Total Sum: {formatAmount(totalAmt)}
              </div>
            </div>
            <DialogFooter className="mt-5">
              <DialogClose>
                <Button type="button" variant="outline" onClick={onCloseDialog}>
                  Cancel
                </Button>
              </DialogClose>
              {!isView && <Button type="submit">Save</Button>}
            </DialogFooter>
          </form>
        </FormProvider>
      )}
    </Dialog>
  );
};

export default MonthlyDistribution;
